<template>
  <div class="jhrxxcjIndex">
    <Header title="监护人信息采集" type="0" route="/homeIndex"></Header>
    <div class="jhrxxcjContent">
      <van-form input-align="right">
        <van-cell-group inset>
          <van-field
            v-model="xm1"
            placeholder="请填写监护人1姓名"
            label="监护人1姓名"
            :readonly="!isUpdate"
          />
          <van-field
            v-model="gx1.mc"
            label="关系"
            readonly
            @click="onShow('关系', 'gx1')"
            placeholder="请点击选择关系"
          />
          <van-field
            v-model="zjlx1.mc"
            label="监护人1证件类型"
            readonly
            @click="onShow('监护人1证件类型', 'zjlx1')"
            placeholder="请点击选择监护人1证件类型"
          />
          <van-field
            v-model="sfzj1"
            placeholder="请填写监护人1证件号码"
            label="监护人1证件号码"
            :readonly="!isUpdate"
          />
        </van-cell-group>
        <van-cell-group inset>
          <van-field
            v-model="xm2"
            placeholder="请填写监护人2姓名"
            label="监护人2姓名"
            :readonly="!isUpdate"
          />
          <van-field
            v-model="gx2.mc"
            label="关系"
            readonly
            @click="onShow('关系', 'gx2')"
            placeholder="请点击选择关系"
          />
          <van-field
            v-model="zjlx2.mc"
            label="监护人2证件类型"
            readonly
            @click="onShow('监护人2证件类型', 'zjlx2')"
            placeholder="请点击选择监护人2证件类型"
          />
          <van-field
            v-model="sfzj2"
            placeholder="请填写监护人2证件号码"
            label="监护人2证件号码"
            :readonly="!isUpdate"
          />
        </van-cell-group>
      </van-form>
    </div>
    <div class="bottom-btn">
      <span v-if="false">
        最后修改时间：
      </span>
      <div>
        <button v-if="!isUpdate" @click="isUpdate = true">修改</button>
        <template v-else>
          <button @click="isUpdate = false">取消</button>
          <button @click="push('save','tj')">提交</button>
        </template>
      </div>
    </div>
    <van-popup v-model="show" round position="bottom">
      <van-picker
        :title="valueList.label"
        show-toolbar
        :columns="valueList.item"
        @confirm="
          (value, index) => {
            onConfirm(value, index, valueList.value);
          }
        "
        @cancel="show = false"
      />
    </van-popup>
  </div>
</template>

<script>
import { Api } from "@/utils/axios";
import { Dialog } from "vant";

export default {
  data() {
    return {
      isUpdate: false,
      xm1: "",
      xm2: "",
      gx1: {},
      gx2: {},
      zjlx1: {},
      zjlx2: {},
      sfzj1: "",
      sfzj2: "",
      show: false,
      valueList: {
        label: "",
        value: "",
        item: []
      },
      columns: {},
      info: {},
      gxArr: [
        {
          text: "父亲",
          value: "0"
        },
        {
          text: "母亲",
          value: "1"
        },
        {
          text: "兄弟姐妹",
          value: "2"
        },
        {
          text: "其他",
          value: "3"
        }
      ]
    };
  },
  created() {
    this.getList("csh");
  },
  methods: {
    async push(val,type) {
      let jhrObj1 = [
        {
          name: "xm",
          type: "姓名",
          xm: this.xm1,
          oldxm: this.info.xm1
        },
        {
          name: "gx",
          type: "关系",
          gx: this.gx1.dm,
          oldgx: this.info.gx1
        },
        {
          name: "gxmc",
          type: "关系名称",
          gxmc: this.gx1.mc,
          oldgxmc: this.info.gxmc
        },
        {
          name: "sfzjm",
          type: "证件类型",
          sfzjm: this.zjlx1.dm,
          oldsfzjm: this.info.sfzjm1
        },
        {
          name: "sfzjmmc",
          type: "证件类型名称",
          sfzjmmc: this.zjlx1.mc,
          oldsfzjmmc: this.info.zjlx
        },
        {
          name: "sfzjh",
          type: "证件号码",
          sfzjh: this.sfzj1,
          oldsfzjh: this.info.sfzjh1
        }
      ];
      let jhrObj2 = [
        {
          name: "xm",
          type: "姓名",
          xm: this.xm2,
          oldxm: this.info.xm2
        },
        {
          name: "gx",
          type: "关系",
          gx: this.gx2.dm,
          oldgx: this.info.gx2
        },
        {
          name: "gxmc",
          type: "关系名称",
          gxmc: this.gx2.mc,
          oldgxmc: this.info.gxmc2
        },
        {
          name: "sfzjm",
          type: "证件类型",
          sfzjm: this.zjlx2.dm,
          oldsfzjm: this.info.sfzjm2
        },
        {
          name: "sfzjmmc",
          type: "证件类型名称",
          sfzjmmc: this.zjlx2.mc,
          oldsfzjmmc: this.info.zjlx2
        },
        {
          name: "sfzjh",
          type: "证件号码",
          sfzjh: this.sfzj2,
          oldsfzjh: this.info.sfzjh2
        }
      ];
      let flag1 = jhrObj1.every(item => {
        return item[`old${item.name}`] == item[item.name];
      });
      let flag2 = jhrObj2.every(item => {
        return item[`old${item.name}`] == item[item.name];
      });
      if (!flag1 || !flag2) {
        const res = await Api.jhrxxcj({
          type: val,
          jhr1: encodeURI(JSON.stringify(jhrObj1)),
          jhr2: encodeURI(JSON.stringify(jhrObj2))
        });
        if (res.code == "1") {
            if("tj"==type){
                this.$toast.success("提交成功！");
            }
          setTimeout(() => {
            this.$router.back();
          }, 1500);
        } else {
          this.$toast.fail(res.Msg);
        }
      }else{
        this.$toast.fail('请先进行修改！')
      }
    },
    open() {
      Dialog.confirm({
        message:
          "因个税改革实施子女教育专项扣除，我自愿填报本人监护人信息以供其参加个税专项扣除，并对所填信息真实性、有效性负责。",
        confirmButtonText: "确认参加",
        cancelButtonText: "放弃参加"
      })
        .then(() => {
          this.isJoin(1);
            this.isUpdate=true;
        })
        .catch(() => {
          this.isJoin(0);
          // on cancel
        });
    },
    async isJoin(val) {
      const res = await Api.jhrxxcj({ type: "xgcjzt", cjzt: val });
      if (res.code == "1") {
          if("0"==val){
              this.xm1="";
              this.gx1.dm="";
              this.gx1.mc="";
              this.sfzj1="";
              this.zjlx1.dm="";
              this.zjlx1.mc="";
              this.xm2="";
              this.gx2.dm="";
              this.gx2.mc="";
              this.sfzj2="";
              this.zjlx2.dm="";
              this.zjlx2.mc="";
              this.push('save','qx');
          }
          this.getList("");
      }
    },
    async getList(type) {
      const res = await Api.jhrxxcj({ type: "ck" });
        if("csh"==type){
            this.open();
        }
      if (res.code == "1"&&res.jhrList.length>0) {
        this.info = res.jhrList[0];

        this.xm1 = this.info.xm1;
        this.xm2 = this.info.xm2;
        this.gx1 = {
          mc: this.info.gxmc,
          dm: this.info.gx1
        };
        this.gx2 = {
          mc: this.info.gxmc2,
          dm: this.info.gx2
        };
        this.zjlx1 = {
          mc: this.info.zjlx,
          dm: this.info.sfzjm1
        };
        this.zjlx2 = {
          mc: this.info.zjlx2,
          dm: this.info.sfzjm2
        };
        this.sfzj1 = this.info.sfzjh1;
        this.sfzj2 = this.info.sfzjh2;
        this.columns.zjlx1 = [
          {
            values: res.zjlxList.map(item => {
              return {
                text: item.dmmc,
                value: item.dm
              };
            })
          }
        ];
        this.columns.zjlx2 = [
          {
            values: res.zjlxList.map(item => {
              return {
                text: item.dmmc,
                value: item.dm
              };
            })
          }
        ];
        this.columns.gx1 = [
          {
            values: this.gxArr
          }
        ];
        this.columns.gx2 = [
          {
            values: this.gxArr
          }
        ];
      }
    },
    onShow(label, value) {
      if (!this.isUpdate) {
        return;
      }
      this.show = true;
      this.valueList.label = label;
      this.valueList.value = value;
      this.valueList.item = this.columns[value];
    },
    onConfirm(value, index, value1) {
      this.show = false;
      this[value1].mc = value[0].text;
      this[value1].dm = value[0].value;
    }
  }
};
</script>
<style lang="less" scoped>
.jhrxxcjIndex {
  background-color: #f7f8fa;
  height: 100%;
  box-sizing: border-box;
  padding-top: 10px;
  .jhrxxcjContent {
    height: calc(~"100% - 111px");
    .van-cell-group {
      & + .van-cell-group {
        margin-top: 10px;
      }
    }
  }
  .bottom-btn {
    box-sizing: border-box;
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    background: #fff;

    // button {
    //   width: 100%;
    //   height: 44px;
    //   background: #7469f8;
    //   border-radius: 3px;
    //   color: #fff;
    // }
    & > span {
      display: inline-block;
      width: 100%;
      box-sizing: border-box;
      padding: 10px;
      text-align: center;
    }
    & > div {
      box-sizing: border-box;
      width: 100%;
      height: 70px;
      padding: 10px 5% 10px 5%;
      display: flex;
      justify-content: space-between;
      button {
        flex: 1;
        height: 44px;
        background: #ecedfd;
        border-radius: 3px;
        color: #7469f8;
      }
      button:last-child {
        margin-left: 10px;
        background: #7469f8;
        color: #fff;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/newPages/student/jhrxxcj/index.vue